/* Kaching owns every selection, price and discount. This only preserves the
 * existing independent card checkout without changing the shopper's cart. */
(() => {
  'use strict';
  if(window.__kvNativeCheckout || window.Shopify?.shop !== 'xdq4ry-he.myshopify.com') return;
  if(!/^\/products\/kind-veil-bb-blur-tinted-moisturizer-spf-30\/?$/.test(location.pathname))return;
  window.__kvNativeCheckout=true;
  const currency=window.Shopify?.currency?.active||'USD';
  let busy=false;
        const createIndependentBundleCart = async items => {
        const query = `mutation KindVeilIndependentCartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              totalQuantity
              cost {
                subtotalAmount { amount currencyCode }
                totalAmount { amount currencyCode }
              }
              lines(first: 20) {
                nodes {
                  id
                  quantity
                  attributes { key value }
                  cost {
                    amountPerQuantity { amount currencyCode }
                    totalAmount { amount currencyCode }
                  }
                  sellingPlanAllocation { sellingPlan { id name } }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      price { amount currencyCode }
                      compareAtPrice { amount currencyCode }
                      weight
                      weightUnit
                      image { url }
                      product { id title handle }
                    }
                  }
                }
              }
            }
            userErrors { field message }
          }
        }`;
        const expectedQuantity = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        const input = {
          lines: items.map(item => ({
            merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
            quantity: Number(item.quantity),
            ...(item.selling_plan
              ? { sellingPlanId: `gid://shopify/SellingPlan/${item.selling_plan}` }
              : {}),
            attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
              key: String(key),
              value: String(value)
            }))
          }))
        };
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ query, variables: { input } })
        });
        const json = await response.json().catch(() => ({}));
        const userErrors = json?.data?.cartCreate?.userErrors || [];
        const cart = json?.data?.cartCreate?.cart;
        if (!response.ok || json.errors?.length || userErrors.length || !cart?.id) {
          throw new Error(userErrors[0]?.message || json.errors?.[0]?.message || 'Unable to create the selected checkout.');
        }
        if (Number(cart.totalQuantity) !== expectedQuantity) {
          throw new Error('The selected bundle could not be verified. Please try again.');
        }
        return cart;
      };

      const createApplicationCheckout = async cart => {
        const sellingPlanGroupId = String(window.yx_product?.selling_plan_groups?.[0]?.id || '');
        const appItems = (cart.lines?.nodes || []).map(line => {
          const variant = line.merchandise;
          const price = Number(line.cost?.amountPerQuantity?.amount || 0);
          const linePrice = Number(line.cost?.totalAmount?.amount || 0);
          const originalPrice = Number(variant?.compareAtPrice?.amount || variant?.price?.amount || price);
          return {
            variantId: variant.id,
            quantity: Number(line.quantity),
            title: variant.product.title,
            variant: variant.title,
            originalPrice,
            price,
            linePrice,
            totalDiscount: Math.max(0, originalPrice * Number(line.quantity) - linePrice),
            productId: variant.product.id,
            url: `/products/${variant.product.handle}?variant=${String(variant.id).split('/').pop()}`,
            image: variant.image?.url || '',
            weight: Number(variant.weight || 0),
            weightUnit: variant.weightUnit || 'GRAMS',
            currencyCode: line.cost?.totalAmount?.currencyCode || currency,
            sellingPlanId: line.sellingPlanAllocation?.sellingPlan?.id || null,
            sellingPlanName: line.sellingPlanAllocation?.sellingPlan?.name || '',
            sellingPlanGroupId: line.sellingPlanAllocation ? sellingPlanGroupId : '',
            properties: Object.fromEntries((line.attributes || []).map(item => [item.key, item.value]))
          };
        });
        if (!appItems.length) throw new Error('The selected bundle is empty.');
        const paidTotal = Number(cart.cost?.totalAmount?.amount || cart.cost?.subtotalAmount?.amount || 0);
        const visitorCookie = (document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith('_bge_ci=')) || '').split('=').slice(1).join('=');
        const payload = {
          cart: {
            items: appItems,
            cartToken: cart.id,
            originalTotalPrice: appItems.reduce((sum, item) => sum + item.originalPrice * item.quantity, 0),
            totalPrice: paidTotal,
            totalDiscount: appItems.reduce((sum, item) => sum + item.totalDiscount, 0),
            totalWeight: appItems.reduce((sum, item) => sum + item.weight * item.quantity, 0),
            itemCount: Number(cart.totalQuantity),
            currency: cart.cost?.subtotalAmount?.currencyCode || currency
          },
          position: { countryCode: 'US', regionCode: '', city: '' },
          checkoutId: '',
          language: window.Shopify?.locale || document.documentElement.lang || 'en',
          extra: {
            view: 'default',
            sourceUrl: window.location.href,
            cookie_id: visitorCookie
          }
        };
        const response = await fetch('https://us.ouyifyapi.com/api/checkout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Shopify-Id': window.yx_shop_name || String(window.Shopify?.shop || '').split('.')[0],
            oyAppVersion: 'v2'
          },
          body: JSON.stringify(payload)
        });
        const json = await response.json().catch(() => ({}));
        const checkoutId = json?.data?.checkoutId || json?.checkoutId;
        if (!response.ok || Number(json?.code || 200) !== 200 || !checkoutId) {
          throw new Error(json?.message || 'Unable to open the application checkout.');
        }
        const subtotal = Number(cart.cost?.subtotalAmount?.amount || 0);
        const shouldOffsetStandardShipping = paidTotal >= 40 && subtotal < 47.06;
        if (shouldOffsetStandardShipping) {
          const discountResponse = await fetch('https://us.ouyifyapi.com/api/checkout/discount/apply', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Shopify-Id': window.yx_shop_name || String(window.Shopify?.shop || '').split('.')[0],
              oyAppVersion: 'v2'
            },
            body: JSON.stringify({
              checkoutId: String(checkoutId),
              discountCode: 'FREE-STANDARD-SHIPPING',
              countryCode: 'US'
            })
          });
          const discountJson = await discountResponse.json().catch(() => ({}));
          if (!discountResponse.ok || Number(discountJson?.code || 200) !== 200) {
            throw new Error(discountJson?.message || 'Unable to apply free standard shipping.');
          }
        }
        return String(checkoutId);
      };


  function selectedItems() {
    window.yxSyncSellingPlanForms?.();
    const widget=document.querySelector('kaching-bundles-block');
    const form=widget?.closest('form')||document.querySelector('product-form form[action*="/cart/add"]');
    if(!widget||!form)throw Error('The bundle is still loading. Please try again.');
    const items=structuredClone(widget.items?.()||[]).filter(i=>i.id&&Number(i.quantity)>0);
    if(!items.length||!items.every(i=>i.properties.__kaching_bundles))throw Error('Please wait for the bundle selection to finish loading and try again.');
    return items;
  }
  document.addEventListener('click',async event=>{
    const button=event.target.closest?.('product-info #yx_checkout');
    if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(busy)return;
    busy=true;button.setAttribute('aria-busy','true');
    const label=button.textContent;
    button.textContent='Preparing checkout…';
    let message=document.getElementById('kv-native-checkout-error');
    if(message)message.remove();
    try{
      const cart=await createIndependentBundleCart(selectedItems());
      const checkoutId=await createApplicationCheckout(cart);
      document.dispatchEvent(new CustomEvent('kindveil:checkout-created',{detail:{checkoutId,value:Number(cart.cost.totalAmount.amount)}}));
      location.assign('/a/s/checkout/'+encodeURIComponent(checkoutId));
    }catch(error){
      message=document.createElement('p');message.id='kv-native-checkout-error';message.setAttribute('role','alert');message.textContent=error.message||'Unable to open checkout. Please try again.';button.after(message);
    }finally{busy=false;button.removeAttribute('aria-busy');button.textContent=label;}
  },true);
})();
